import "core-js/modules/es.array.push.js";
import { defineStore } from 'pinia';
import { base64encode } from '@/utils';
const createApiStoreKey = (key, ...params) => {
  if (!key) return '';
  const createParamKey = param => {
    if (!param) return '';
    const result = [];
    if (Array.isArray(param)) {
      for (const item of param) {
        const arrItemKey = createParamKey(item);
        result.push(arrItemKey);
      }
      return result.join(',');
    } else if (typeof param === 'object') {
      const objKeys = Object.keys(param);
      objKeys.sort((a, b) => {
        if (a > b) return -1;else if (a < b) return 1;
        return 0;
      });
      for (const k of objKeys) {
        result.push(`${k}=${param[k]}`);
      }
      return result.join('&');
    } else {
      return `${param}`;
    }
  };
  const paramsKey = createParamKey(params);
  let result = key;
  if (paramsKey.length > 0) {
    result = `${key}?${paramsKey}`;
  }
  return base64encode(result);
};
export const useCacheFetch = defineStore('icloud-fetch-cache', {
  id: 'icloud-fetch-cache',
  state: () => ({
    caches: {}
  }),
  getters: {
    getCache(state) {
      return key => state.caches[key];
    }
  },
  actions: {
    /**
             * 带缓存的数据请求
             * @param key
             * @param api
             * @param expire
             * @param apiParams
             * @returns {Promise<Awaited<*>|*>}
             */
    async fetch({
      key,
      api,
      expire = 10 * 1000
    } = {}, ...apiParams) {
      if (!api) return Promise.reject(new Error('未传入函数api参数'));
      const dataKey = createApiStoreKey(key, apiParams);
      const {
        [dataKey]: {
          lastTime = 0,
          data
        } = {}
      } = this.caches || {};
      const nowTime = new Date().getTime();
      if (nowTime - lastTime < expire && data) {
        return Promise.resolve(data);
      }
      // 重新加载数据
      try {
        const res = await api(...apiParams);
        this.caches[dataKey] = {
          lastTime: nowTime,
          data: res
        };
        return Promise.resolve(res);
      } catch (er) {
        return Promise.reject(er);
      }
    }
  },
  persist: {
    key: 'icloud-fetch-cache',
    storage: localStorage
  }
});